
import { Component, Vue, Provide } from 'vue-property-decorator'
import { State, Mutation, Getter, Action } from 'vuex-class'
import chunk from 'lodash/chunk'

import DarkModeBtn from '@/components/DarkModeBtn.vue'
import NoteCard from '@/components/NoteCard.vue'
import AddNote from '@/components/NewNote.vue'

import { INoteList, INewNote, INote } from '../interface/INote'
import { upload } from '../Util'

function createStateProxy (instance: any) {
  return new Proxy({}, {
    get (target, attr) {
      if (!instance[attr]) {
        return undefined
      } else {
        return instance[attr]
      }
    }
  })
}

@Component({
  components: {
    DarkModeBtn,
    NoteCard,
    AddNote
  },
  provide () {
    const state = createStateProxy(this)
    return {
      state
    }
  }
})
export default class Home extends Vue {
  isListMode = false
  addNoteIsShow = false

  onlyStarNote = false

  searchField = ''
  searchToggle = false

  @State('darkMode') darkMode!: Boolean
  @State('note') note!: Map<string, INote>
  @Getter('noteList') noteList!: INoteList[]
  listTracker = 1

  @Mutation('modeToggle') modeToggle!: (value: boolean) => void
  @Mutation('noteStarToggle') noteStarToggle!: (id: String) => void
  @Mutation('addNewNote') addNewNote!: (payload: INewNote) => void

  @Action('importNotes') importNotes!: (value: string) => void
  @Action('exportNotes') exportNotes!: () => void

  get list () {
    let x = this.listTracker
    let list = [...this.note].map(([key, { coverClass, title, id, star, coverImage }]) => ({ cover: coverClass, title, id, star, coverImage }))
    if (this.searchToggle) {
      list = list.filter(({ title }) => title.startsWith(this.searchField))
    }
    return chunk(list.filter(n => this.onlyStarNote ? n.star : true), this.isListMode ? 2 : 4)
  }

  openNote (id: string) {
    console.log(id)
    if (id !== '0') {
      this.$router.push('/note/' + id)
    } else {
      this.addNewNoteTrigger()
    }
  }

  addNewNoteTrigger () {
    this.addNoteIsShow = true
  }

  newNoteOnConfirm (arg: INewNote) {
    console.log(arg)
    this.addNewNote(arg)
    this.addNoteIsShow = false
    this.listTracker += 1
  }

  starOnClick (id: string) {
    console.log(id)
    this.noteStarToggle(id)
    this.listTracker += 1
  }

  searchOnClick () {
    if (this.searchField === '') this.searchToggle = false
    else this.searchToggle = true
  }

  uploadNotesJson () {
    let element = this.$refs['uploadFile'] as HTMLElement
    element.click()
  }

  async uploadFileOnChange (evt: any) {
    let file = evt.target.files[0]
    let notes = await upload(file)
    try {
      // do the validate
      let notesJson: any = JSON.parse(notes)
      this.importNotes(notes)
    } catch (error) {
      alert(error)
      return false
    }
  }
}
